"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = designViewReducer;
var _Actions = require("./Actions");
var _find = _interopRequireDefault(require("lodash/find"));
var _get = _interopRequireDefault(require("lodash/get"));
var configuratorActionTypes = _interopRequireWildcard(require("../Configurator/Actions"));
var _Transformers = require("./Transformers");
var _Selectors = require("../ConfigurationMode/Selectors");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var orderDesignAreasBySize = function orderDesignAreasBySize(designAreas) {
  return designAreas && _toConsumableArray(designAreas).sort(_Transformers.compareDesignAreasBySize);
};
var prepareDesignViews = function prepareDesignViews(designViews) {
  return designViews.map(function (designView) {
    return _objectSpread(_objectSpread({}, designView), {}, {
      designAreas: orderDesignAreasBySize(designView.designAreas)
    });
  });
};
var initialState = {
  designViews: [],
  selectedDesignView: {},
  autogeneratedDesignViews: [],
  viewThumbnailImages: []
};
function designViewReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case _Actions.actionTypes.SELECT_DESIGN_VIEW:
      {
        var designViewIdentifier = action.designViewIdentifier;
        var designView = (0, _find["default"])(state.designViews, {
          identifier: designViewIdentifier
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedDesignView: designView
        });
      }
    case configuratorActionTypes.RECEIVE_DESIGNER_DATA:
      {
        var autogeneratedDesignViews = state.autogeneratedDesignViews;
        var designViews = action.data.designViews;
        if (!designViews || !designViews.length) {
          // if there are no design views defined, use the autogenerated ones as fallback
          // use-case: missing visual maintenance setup for layer type visualization (designer only)
          if (autogeneratedDesignViews.length) {
            return _objectSpread(_objectSpread({}, state), {}, {
              designViews: autogeneratedDesignViews
            });
          }
          return state;
        }
        if (autogeneratedDesignViews.length) {
          // if the design views are already defined by the viewImages they need to be merged
          var updatedDesignViews = autogeneratedDesignViews.map(function (designView) {
            return _objectSpread(_objectSpread({}, designViews.find(function (_ref) {
              var identifier = _ref.identifier;
              return designView.identifier === identifier;
            })), designView);
          });
          return _objectSpread(_objectSpread({}, state), {}, {
            designViews: prepareDesignViews(updatedDesignViews),
            selectedDesignView: {}
          });
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          designViews: prepareDesignViews(designViews),
          selectedDesignView: {}
        });
      }
    case configuratorActionTypes.RECEIVE_CONFIGURATION:
      {
        var viewImages = (0, _get["default"])(action, 'data.visualizationData.viewImages');
        var viewIdentifiers = viewImages && Object.keys(viewImages);
        if (viewIdentifiers && viewIdentifiers.length) {
          var viewThumbnailImages = (0, _get["default"])(action, 'data.visualizationData.viewThumbImages');
          var _autogeneratedDesignViews = viewIdentifiers.map(function (identifier) {
            return {
              identifier: identifier
            };
          });
          // if designer mode is enabled, the design views are loaded in a separate action
          // so it's not stored directly as designViews
          if ((0, _Selectors.getConfigurationModes)((0, _get["default"])(action, 'data.item')).designer) {
            return _objectSpread(_objectSpread({}, state), {}, {
              designViews: [],
              selectedDesignView: {},
              autogeneratedDesignViews: _autogeneratedDesignViews,
              viewThumbnailImages: viewThumbnailImages
            });
          }
          // otherwise designViews are not expected from other actions
          // so the autogenerated ones should be used as fallback
          var selectedDesignView = _autogeneratedDesignViews[0];
          return _objectSpread(_objectSpread({}, state), {}, {
            designViews: _autogeneratedDesignViews,
            selectedDesignView: selectedDesignView,
            autogeneratedDesignViews: _autogeneratedDesignViews,
            viewThumbnailImages: viewThumbnailImages
          });
        }
        // receiving a new configuration should always reset the design view state to not mix them up
        return _objectSpread(_objectSpread({}, state), {}, {
          designViews: [],
          selectedDesignView: {},
          autogeneratedDesignViews: [],
          viewThumbnailImages: []
        });
      }
  }
  return state;
}